module.exports = __webpack_public_path__ + "public/images/main-logo.d4e9fa67118a0288b79bf6d255bf29d5.svg";